import { forwardRef } from 'react';
import * as LabelPrimitive from '@radix-ui/react-label';
import { cn } from '@/lib/cn';

export const Label = forwardRef<
  React.ElementRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root>
>(function Label({ className, ...rest }, ref) {
  return (
    <LabelPrimitive.Root
      ref={ref}
      className={cn(
        'mb-1.5 inline-block',
        'font-medium text-[var(--color-ink)] text-[var(--text-sm)]',
        'leading-[var(--leading-snug)]',
        'select-none',
        className,
      )}
      {...rest}
    />
  );
});
